import React from 'react';
import useReveal from '../hooks/useReveal';
import photoMain from '../assets/images/DSC04307.JPG';
import photoSub from '../assets/images/DSC05383.JPG';

const CHECKLIST = [
  'ทีมสัตวแพทย์ผู้เชี่ยวชาญที่ผ่านการฝึกอบรมอย่างดี',
  'อุปกรณ์ทางการแพทย์ทันสมัย เอกซเรย์ดิจิตอล อัลตราซาวด์',
  'ตรวจวินิจฉัย รักษา ผ่าตัด และคำปรึกษาครบวงจร',
  'ทำเลสะดวกใจกลางทองหล่อ พร้อมบริการรับ-ส่งถึงบ้าน',
];

const STATS = [
  { value: '20+', label: 'ปีประสบการณ์' },
  { value: '5', label: 'บริการครบวงจร' },
  { value: '24 ชม.', label: 'ดูแลโรงแรมสัตว์เลี้ยง' },
];

function About() {
  const sectionRef = useReveal();

  return (
    <section id="about" className="reveal" ref={sectionRef}>
      <div className="about-container">
        <div className="about-media">
          <img src={photoMain} alt="บรรยากาศภายในโรงพยาบาลสัตว์ Pet Direct" loading="lazy" />
          <img
            src={photoSub}
            alt="ทีมงานกำลังดูแลสัตว์เลี้ยง"
            className="about-media-sub"
            loading="lazy"
          />
        </div>
        <div className="about-body">
          <span className="section-eyebrow">About Us</span>
          <h2 className="section-title">โรงพยาบาลสัตว์ PetDirect</h2>
          <p className="about-text">
            โรงพยาบาลสัตว์ PetDirect ตั้งอยู่ในทำเลที่สะดวกสบายใจกลางทองหล่อ
            เรามุ่งมั่นดูแลน้องๆ สัตว์เลี้ยงของคุณด้วยความเอาใจใส่และปลอดภัย
            เสมือนสมาชิกในครอบครัว เพื่อให้สัตว์เลี้ยงของคุณมีสุขภาพที่แข็งแรง
            และมีความสุขในทุกวัน
          </p>
          <ul className="about-checklist">
            {CHECKLIST.map((item) => (
              <li key={item}>
                <span className="material-icons" aria-hidden="true">check_circle</span>
                {item}
              </li>
            ))}
          </ul>
          <dl className="about-stats">
            {STATS.map((stat) => (
              <div key={stat.label}>
                <dt>{stat.value}</dt>
                <dd>{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}

export default About;
